<template>
    <div class="orderDetail">
        <div class="orderDetail_head">
            <span>优惠券领取</span>
        </div>
        <div class="orderDetail_content">
            <span class="num_text">
                <span v-show="details_complete">{{ detailsdata.amount }}元</span>
                <span v-show="details_complete" class="iconfont icon-duihao">领取成功</span>
                <span v-show="!details_complete" class="iconfont icon-cuo">领取失败<br>{{ detailsdata.msg }}</span>
            </span>
        </div>
        <div class="bts">
            <div>
                <div @click="goHome">返回首页</div>
            </div>
        </div>
    </div>
</template>

<script>
    import common from "../common";

    export default {
        name: "foodCode",
        data() {
            return {
                detailsdata: "",
                details_complete: true,//订单是否完成
                token: ""
            }
        },
        methods: {
            goHome() {
                this.$router.replace("/");
            }
        },
        mounted() {
            //判断cookie中是否存在token
            let ifcookietoken = document.cookie.indexOf("token=") != -1;
            if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
                this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
            } else if (ifcookietoken) {
                this.token = common.getCookie("token");
            } else {
                this.$router.replace({name: 'login'});
            }
            let token = this.token;
            let code = this.$route.query.code;
            let price = this.$route.query.price;
            let adminid = this.$route.query.adminid;
            let querystring = require('querystring');
            this.$api.post('wx/service/foodCode',
                querystring.stringify({
                    code,
                    price,
                    adminid,
                    token
                })
            ).then(data => {
                if (data.data.status == 1) {
                    this.detailsdata = data.data.data;
                } else {
                    this.detailsdata = data.data.data;
                    this.details_complete = false;
                    //common.toast(data.msg);
                }
            }).catch(err => {
                console.log(err);
            })
        }
    }
</script>

<style>
    .orderDetail {
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        background: white;
        display: -webkit-flex;
        flex-direction: column;
        font-size: .8rem;
    }

    .orderDetail > .orderDetail_head {
        background: #f5f5f5;
        width: 100vw;
        height: 10vh;
        padding: 0 10vw;
        line-height: 10vh;
        font-size: .8rem;
        text-align: left;
    }

    .orderDetail_content {
        width: 100vw;
        height: 50vh;
        background: white;
        display: -webkit-flex;
        flex-direction: column;
        justify-content: space-around;
    }

    .num_text {
        color: #0097fe;
        font-size: 1rem;
    }

    .time_text {
        font-size: .8rem;
    }

    .orderDetail .icon-cuo {
        font-size: 1rem;
        color: red;
    }

    .orderDetail .icon-duihao {
        font-size: 1rem;
    }

    .orderDetail .bts {
        width: 60vw;
        height: 8vh;
        text-align: center;
        margin: 10vh auto;
        line-height: 8vh;
        color: white;
        font-size: .6rem;
        border-radius: 8px;
        font-weight: bold;
        background: #0097fe;
    }

    .addClass {
        padding: 20px !important;
    }

    .addClass > span {
        padding-top: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/foodCode.vue